import { getSpecialtiesNServiceType } from 'api/operation';
import { useCallback, useEffect, useState } from 'react';
import { ISpecialtyNServiceTypeResponse } from 'types/helloKlarity';

const useGetSpecialtyNServiceType = (providerId: number):[ISpecialtyNServiceTypeResponse | undefined, boolean, string, (providerId: number) => void] => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState<ISpecialtyNServiceTypeResponse>();
    const [error, setError] = useState('');

    const fetch = useCallback(async (pid: number) => {
        setLoading(true);

        try {
            const res = await getSpecialtiesNServiceType(pid);

            if (res && !res.error) {
                setData(res.data?.data);
            } else {
                setError(res?.error);
            }
        } catch (e) {
            console.error(e);
        }

        setLoading(false);
    }, []);

    useEffect(() => {
        if (providerId) {
            fetch(providerId);
        }
    }, [fetch, providerId]);

    return [data, loading, error, fetch];
};

export default useGetSpecialtyNServiceType;
